<template>
    <ion-page class="page-profile">
        <ion-header class="tablet-header">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <div class="shimmer-box back-button-shimmer"></div>
                </ion-buttons>
                <ion-title>
                    <div class="shimmer-box title-shimmer"></div>
                </ion-title>
            </ion-toolbar>
        </ion-header>

        <ion-content>
            <ion-card>
                <ion-card-content>
                    <ion-grid>
                        <ion-row>
                            <ion-col>
                                <div class="shimmer-box subtitle-shimmer"></div>
                            </ion-col>
                            <ion-col size="auto">
                                <div class="shimmer-box button-shimmer"></div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>

                    <ion-list>
                        <ion-item detail="false" v-for="n in 7" :key="n">
                            <div class="shimmer-box item-shimmer"></div>
                        </ion-item>
                    </ion-list>
                </ion-card-content>
            </ion-card>

            <div class="delete-account">
                <div class="shimmer-box delete-shimmer"></div>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
export default {
    name: 'ProfileShimmer'
}
</script>

<style scoped>
.shimmer-box {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
}

@keyframes shimmer {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

.back-button-shimmer {
    width: 40px;
    height: 40px;
    margin: 8px;
}

.title-shimmer {
    width: 150px;
    height: 24px;
}

.subtitle-shimmer {
    width: 200px;
    height: 30px;
    margin-bottom: 20px;
}

.button-shimmer {
    width: 80px;
    height: 30px;
}

.item-shimmer {
    width: 100%;
    height: 60px;
}

.delete-shimmer {
    width: 100%;
    height: 60px;
}

ion-item {
    --padding-start: 0;
    --inner-padding-end: 0;
}
</style>